import React, { useEffect, useState } from "react";
import styles from "./ContractorHome.module.css";
import { HiLocationMarker } from "react-icons/hi";
import { BsHddStackFill, BsCalendar3EventFill } from "react-icons/bs";
import { MdPeople } from "react-icons/md";
import { FaImages } from "react-icons/fa";
import man from "../../assets/man1.png";
import before from "../../assets/trash1.png";
import after from "../../assets/trash2.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AuthMiddleware from "../../store/Middlewares/AuthMiddleware";
import CategoriesMiddleware from "../../store/Middlewares/CategoriesMiddleware";
import ContractorMiddleware from "../../store/Middlewares/ContractorMiddleware";
import dummyImg from "../../assets/dummy.png";
import { IMG_URL } from "../../store/Apis";
import { Modal } from "antd";
import { AntdSubmit } from "../../components";

function ContractorHome() {
  const [Active, setActive] = useState();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const category = useSelector((state) => state.CategoriesReducer.CategoryList);
  const [employeeWork, setemployeeWork] = useState(null);
  const [ImageModal, setImageModal] = useState(false);
  const [SelectedImage, setSelectedImage] = useState(null);
  const [VideoModal, setVideoModal] = useState(false);
  const [SelectedVideo, setSelectedVideo] = useState(null);
  const user = useSelector((state) => state.AuthReducer.user);
  console.log("================user =================", user);
  const [subscribeModal, setsubscribeModal] = useState(
    user?.is_subscribed ? false : true
  );
  let updatedUser = {
    ...user,
    get_started: 1,
  };

  console.log("employeeWork", employeeWork);
  console.log("user", user);

  useEffect(() => {
    updateOnlineStatus();
    getCategories();
    getEmployeeWork();
    getLanguage();
  }, []);

  const updateOnlineStatus = () => {
    dispatch(AuthMiddleware.getUserInfo())
    let userData = {
      status: 1,
      user: updatedUser,
    };
    dispatch(AuthMiddleware.LoginUpdateStatus(userData));
  };

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem("@selectedLanguage");
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  const getCategories = () => {
    dispatch(CategoriesMiddleware.getCategories());
  };

  const getEmployeeWork = () => {
    dispatch(ContractorMiddleware.getEmployeeWork()).then((data) => {
      setemployeeWork(data?.data);
    });
  };

  const options = [
    {
      id: 1,
      name: "Location",
      icon: <HiLocationMarker className={styles.icon} />,
      onClick: () => {
        navigate("/contractorHome/Location");
      },
    },
    {
      id: 2,
      name: "Checklist",
      icon: <BsHddStackFill className={styles.icon} />,
      onClick: () => {
        navigate("/contractorHome/Checklist");
      },
    },
    {
      id: 3,
      name: "Weekly Inspection",
      icon: <BsCalendar3EventFill className={styles.icon} />,
      onClick: () => {
        navigate("/contractorHome/WeeklyInspection");
      },
    },
    {
      id: 4,
      name: "Customers",
      icon: <MdPeople className={styles.icon} />,
      onClick: () => {
        navigate("/contractorHome/Customers");
      },
    },
  ];

  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.heading}>
        {t("Welcome")} , <span>{user?.name}</span>
      </h1>

      <div className={styles.top_tab_view}>
        {options.map((item, index) => {
          return (
            <button
              className={styles.top_tab}
              onClick={() => {
                item.onClick();
                setActive(item);
              }}
            >
              <div>{item?.icon}</div>
              <h2 className={styles.tab_heading}> {t(item?.name)}</h2>
            </button>
          );
        })}
      </div>
      {employeeWork ? (
        <div className={styles.box}>
          <div className={styles.box_sub_view}>
            <div>
              <img
                src={
                  employeeWork?.cleaner_image
                    ? IMG_URL + employeeWork?.cleaner_image
                    : dummyImg
                }
                className={styles.profile_image}
              />
            </div>
            <div className={styles.box_heading_view}>
              <h1 className={styles.box_heading}>
                {employeeWork?.cleaner_name}
              </h1>
              <h5 className={styles.span}>{employeeWork?.service_name}</h5>
              <p className={styles.text}>{employeeWork?.details}</p>
            </div>
          </div>

          <div className={styles.flex}>
            <FaImages className={styles.icon} color="#f6921e" />
            <h1 className={styles.box_headingx}>
              {t("Picture (Before and After Work)")}
            </h1>
          </div>

          <div className={styles.box_images_container}>
            {employeeWork?.before_type == "video" || employeeWork?.before_type?.match("video/*") ? (
              <div className={styles.box_image_view}>
                {/* <img src={before} className={styles.box_image} /> */}
                {/* <iframe
                  className={styles.box_image}
                  src={IMG_URL + employeeWork?.before}
                ></iframe> */}
                <video
                  className={styles.box_image}
                  autoPlay
                  controls
                // src={IMG_URL + employeeWork?.after}
                >
                  <source src={IMG_URL + employeeWork?.before} />
                </video>
                <h3 className={styles.box_headingz}>{t("Before")}</h3>
              </div>
            ) : employeeWork?.before_type == "photo" || employeeWork?.before_type?.match("image/*") ? (
              <div className={styles.box_image_view}>
                <a
                  href={IMG_URL + employeeWork?.before}
                  target="_blank"
                  title="Download"
                >
                  <img
                    src={IMG_URL + employeeWork?.before}
                    className={styles.box_image}
                  />
                </a>
                <h3 className={styles.box_headingz}>{t("Before")}</h3>
              </div>
            ) : null}

            {employeeWork?.after_type == "video" || employeeWork?.after_type?.match("video/*") ? (
              <div className={styles.box_image_view}>
                <video
                  className={styles.box_image}
                  autoPlay
                  controls
                // src={IMG_URL + employeeWork?.after}
                >
                  <source src={IMG_URL + employeeWork?.after} />
                </video>
                <h3 className={styles.box_headingz}>{t("After")}</h3>
              </div>
            ) : employeeWork?.after_type == "photo" || employeeWork?.after_type?.match("image/*") ? (
              <div className={styles.box_image_view}>
                <a
                  href={IMG_URL + employeeWork?.after}
                  target="_blank"
                  title="Download"
                >
                  <img
                    src={IMG_URL + employeeWork?.after}
                    className={styles.box_image}
                  />
                </a>
                <h3 className={styles.box_headingz}>{t("After")}</h3>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}

      <Modal
        open={subscribeModal}
        footer={null}
        closable={false}
        className="modalStyle"
        style={{
          border: "2px solid #f6921e",
          backgroundColor: "#0F0F0F",
          borderRadius: "10px",
          color: "white",
        }}
      >
        <div className={styles.modalHead}>
          <h1>Subscribe</h1>
          <p>Please subscribe to continue</p>
        </div>
        <div
          onClick={() => {
            setsubscribeModal(false);
            navigate("/subscription");
          }}
          className={styles.ModalButton}
        >
          <AntdSubmit
            text={"Subscribe"}
            buttonStyle={{ margin: "15px 0px", height: "50px" }}
          />
        </div>
        {/* <button
          onClick={() => {
            setsubscribeModal(false);
            navigate("/subscription");
          }}
          className={styles.ModalButton}
        >
          Subscribe
        </button> */}
      </Modal>
    </div>
  );
}

export default ContractorHome;
